var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.6064 10.6008L12.0024 12.9228L15.276 10.6644L22.614 17.904C22.4204 17.9672 22.2156 17.9992 21.9996 18H2.0004C1.7364 18 1.4844 17.9484 1.2528 17.856L8.6064 10.6008ZM24 4.6512V15.9996C24 16.296 23.9352 16.5768 23.82 16.83L16.6272 9.7332L24 4.6512ZM0 4.7148L7.2504 9.6732L0.1272 16.7028C0.0437553 16.4777 0.00069479 16.2397 0 15.9996L0 4.7148ZM21.9996 0C23.1036 0 24 0.8952 24 2.0004V2.7036L11.9976 10.9776L0 2.772V2.0004C0 0.8964 0.8952 0 2.0004 0H21.9996Z",
    fill: "#615E83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.2789f40d0c1789d7b27088668ed34aee.svg";
export { ForwardRef as ReactComponent };